import { object, string } from 'yup';

export const validationSchema = object().shape({
  firstName: string().nullable(),
  lastName: string().nullable(),
  nickname: string().nullable(),
  gender: string().nullable(),
  birthDate: string().nullable(),
});
